import React, { useState, useRef, useEffect, useCallback } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  message,
  Input,
  Row,
  Col,
  Collapse,
  PageHeader,
  Button,
  Checkbox,
} from "antd";

import {
  formItemLayout,
  smallFormItemLayout,
  tailFormItemLayout,
} from "./../../utils/Layouts";
import {
  EditOutlined,
  CloseOutlined,
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onDeleteItem,
  onChange,
  onFinalize,
} from "../../utils/form_utilities";
import moment from "moment";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";

import {
  onCustomerSearch,
  onStockSearch,
  addKeysToArray,
  onWarehouseSearch,
  onSupplierSearch,
  onBankSearch,
  onChartOfAccountSearch,
  onExpenseCategorySearch,
} from "../../utils/utilities";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import TextAreaGroup from "../../commons/TextAreaGroup";
import numberFormat from "../../utils/numberFormat";
import round from "../../utils/round";
import axios from "axios";
import { TAX_TYPE_VAT, vat_type_options } from "../../utils/Options";
import { sumBy } from "lodash";
import WarehouseFormModal from "../modals/WarehouseFormModal";

import FormButtons from "../../commons/FormButtons";

import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import RecordButtons from "../../commons/RecordButtons";
import {
  PAYMENT_TYPE_CHECK,
  SETTING_ACCOUNTS_PAYABLE,
  VAT_TYPE_PERCENT,
} from "../../utils/constants";
import ExpenseCategoryFormModal from "../modals/ExpenseCategoryFormModal";

const { Content } = Layout;
const { Panel } = Collapse;

const url = "/api/check-vouchers/";
const title = "Disbursement Voucher Form";

const initialValues = {
  _id: null,
  cv_no: null,
  date: moment(),
  supplier: null,
  remarks: "",
  items: [],
  credit_memo_items: [],
  advance_payment_items: [],
  po_credit_items: [],
  discount_items: [],
  deduction_items: [],
  expense_items: [],
  additional_debit_memo_items: [
    {
      invoice_no: "",
      invoice_date: "",
      amount: "",
      is_wtax_applicable: false,
      description: "",
    },
  ],
  addback_items: [
    {
      invoice_no: "",
      invoice_date: "",
      amount: "",
      description: "",
    },
  ],
  additional_items: [
    {
      invoice_no: "",
      invoice_date: "",
      amount: "",
      is_wtax_applicable: false,
      description: "",
    },
  ],
  printed: null,
  net_amount: 0,

  wtax_rate: 0,
  wtax_type: VAT_TYPE_PERCENT,
  check_name: "",
  check_date: null,
  check_no: "",

  voucher_amount: "",
  wtax_amount: "",
  total_discounts: 0,
  total_deductions: 0,
  total_expenses: 0,
  total_debit: 0,
  total_credit: 0,
  accounts_payable_account: null,
  wtax_account: null,
};

const initialItemValues = {};
const initialDiscountItemValues = {};
const initialDeductionItemValues = {};
const initialExpenseItemValues = {};

const date_fields = ["date", "check_date"];
const transaction_counter = {
  label: "DV #",
  key: "cv_no",
};

export default function CheckVoucherForm() {
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);

  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);
  const [item, setItem] = useState(initialItemValues);
  const [loading, setLoading] = useState(false);
  const [loading_state, setLoadingState] = useState(false);
  const [page_size, setPageSize] = useState(100);

  const [discount_item, setDiscountItem] = useState(initialDiscountItemValues);
  const [deduction_item, setDeductionItem] = useState(
    initialDeductionItemValues
  );
  const [expense_item, setExpenseItem] = useState(initialExpenseItemValues);
  const [state_loading, setStateLoading] = useState({
    cancel: false,
  });

  const [options, setOptions] = useState({
    customers: [],
    stocks: [],
    warehouses: [],
    suppliers: [],
    banks: [],
    chart_of_accounts: [],
  });

  const [state, setState] = useState(initialValues);
  const [row_selected, setRowSelected] = useState(null);
  const [search_state, setSearchState] = useState({
    period_covered: [null, null],
    supplier: null,
    cv_no: "",
  });

  const warehouseFormModal = useRef(null);
  const expenseCategoryFormModal = useRef(null);

  const records_column = [
    {
      title: "CV #",
      dataIndex: "cv_no",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => moment(date).format("MM/DD/YYYY"),
    },
    {
      title: "Supplier",
      dataIndex: ["supplier"],
      render: (supplier) => `${supplier.name}`,
    },
    {
      title: "Bank",
      dataIndex: ["bank", "name"],
    },

    {
      title: "Check No.",
      dataIndex: "check_no",
    },
    {
      title: "Check Date",
      dataIndex: "check_date",
      render: (date) => date && moment(date).format("MM/DD/YYYY"),
    },

    {
      title: "Remarks",
      dataIndex: "remarks",
    },
    {
      title: "Voucher Amount",
      dataIndex: "voucher_amount",
      align: "right",
      render: (value) => <span>{numberFormat(value)}</span>,
    },

    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      render: (status, record, index) => {
        if (record.deleted && record.deleted.date) {
          return (
            <span className="has-text-danger has-text-weight-bold">VOIDED</span>
          );
        }

        return <span>{status && status.approval_status}</span>;
      },
    },
    {
      title: "",
      key: "action",
      width: 10,
      align: "center",
      render: (text, record) => (
        <EditOutlined
          onClick={() =>
            edit({
              record,
              setState,
              setErrors,
              setRecords,
              url,
              date_fields,
            })
          }
        />
      ),
    },
  ];

  const items_column = [
    {
      title: "PO #",
      dataIndex: "po_no",
    },
    {
      title: "PO Date",
      dataIndex: "date",
      render: (date) => date && moment(date).format("MM/DD/YYYY"),
    },
    {
      title: "Terms",
      dataIndex: ["account", "terms"],
    },
    // {
    //   title: "Remarks",
    //   dataIndex: "remarks",
    // },
    {
      title: "Expense",
      dataIndex: ["expense_category"],
      render: (expense_category, record, record_index) => {
        return (
          record.footer !== 1 && (
            <SelectFieldGroup
              value={expense_category?.name}
              onSearch={(value) =>
                onExpenseCategorySearch({ value, options, setOptions })
              }
              onFocus={() =>
                onExpenseCategorySearch({ value: "", options, setOptions })
              }
              onChange={(index) => {
                const expense_category =
                  options.expense_categories?.[index] || null;

                if (expense_category) {
                  setState((prevState) => {
                    const items = [...(prevState.items || [])];

                    items[record_index].expense_category = expense_category;

                    return {
                      ...prevState,
                      items,
                    };
                  });
                }
              }}
              error={errors.stock?.name}
              formItemLayout={null}
              data={options.expense_categories}
              column="display_name"
              onAddItem={() =>
                expenseCategoryFormModal.current.open(record_index, "items")
              }
            />
          )
        );
      },
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      width: 150,
      align: "right",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "Total Received Amount",
      dataIndex: "total_received_amount",
      width: 150,
      align: "right",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "Balance after Payment",
      dataIndex: "balance",
      width: 150,
      align: "right",
      render: (value, record, index) => (
        <div
          onClick={(e) => {
            e.preventDefault();
            const items = [...state.items];
            items[index] = {
              ...items[index],
              payment_amount: round(value),
            };

            setState((prevState) => ({
              ...prevState,
              items,
            }));
          }}
        >
          {numberFormat(value)}
        </div>
      ),
    },
    {
      title: "Payment Amount",
      dataIndex: "payment_amount",
      align: "right",
      width: 150,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 ? (
            <Input
              className="has-text-right"
              type="number"
              step={0.01}
              value={value}
              onChange={(e) => {
                const value = e.target.value;

                if (value.includes(",")) {
                  message.error("Amount should be not contain a comma");
                  return;
                }

                const items = [...state.items];
                items[index] = {
                  ...items[index],
                  payment_amount: value,
                };

                setState((prevState) => ({
                  ...prevState,
                  items,
                }));
              }}
            />
          ) : (
            numberFormat(value)
          )}
        </span>
      ),
    },

    {
      title: "",
      width: 50,
      render: (value, record, index) =>
        record.footer !== 1 && (
          <Checkbox
            onChange={(e) => {
              const checked = e.target.checked;
              let items;
              if (checked) {
                items = [...state.items];
                items[index] = {
                  ...items[index],
                  payment_amount: round(items[index].balance),
                };
              } else {
                items = [...state.items];
                items[index] = {
                  ...items[index],
                  payment_amount: "",
                };
              }
              setState((prevState) => {
                return {
                  ...prevState,
                  items: items,
                };
              });
            }}
          />
        ),
      align: "center",
    },

    {
      title: "",
      key: "action",
      width: 50,
      align: "center",
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) &&
            isEmpty(state.deleted) &&
            record.footer !== 1 && (
              <DeleteOutlined
                onClick={() =>
                  onDeleteItem({
                    field: "items",
                    index,
                    setState,
                  })
                }
              />
            )}
        </span>
      ),
    },
  ];

  const debit_memo_column = [
    {
      title: "DM #",
      dataIndex: "dm_no",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => date && moment(date).format("MM/DD/YYYY"),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
    },
    {
      title: "Expense",
      dataIndex: ["expense_category"],
      render: (expense_category, record, record_index) => {
        return (
          record.footer !== 1 && (
            <SelectFieldGroup
              value={expense_category?.name}
              onSearch={(value) =>
                onExpenseCategorySearch({ value, options, setOptions })
              }
              onFocus={() =>
                onExpenseCategorySearch({ value: "", options, setOptions })
              }
              onChange={(index) => {
                const expense_category =
                  options.expense_categories?.[index] || null;

                if (expense_category) {
                  setState((prevState) => {
                    const items = [...(prevState.debit_memo_items || [])];

                    items[record_index].expense_category = expense_category;

                    return {
                      ...prevState,
                      debit_memo_items: items,
                    };
                  });
                }
              }}
              error={errors.stock?.name}
              formItemLayout={null}
              data={options.expense_categories}
              column="display_name"
              onAddItem={() =>
                expenseCategoryFormModal.current.open(
                  record_index,
                  "debit_memo_items"
                )
              }
            />
          )
        );
      },
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      width: 150,
      align: "right",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "Total Claimed Amount",
      dataIndex: "total_claimed_amount",
      width: 150,
      align: "right",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "Balance",
      dataIndex: "balance",
      width: 150,
      align: "right",
      render: (value, record, index) => (
        <div
          onClick={(e) => {
            e.preventDefault();
            const items = [...state.items];
            items[index] = {
              ...items[index],
              payment_amount: round(value),
            };

            setState((prevState) => ({
              ...prevState,
              debit_memo_items: items,
            }));
          }}
        >
          {numberFormat(value)}
        </div>
      ),
    },
    {
      title: "Claim Amount",
      dataIndex: "claim_amount",
      align: "right",
      width: 150,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 ? (
            <Input
              className="has-text-right"
              type="number"
              step={0.01}
              value={value}
              onChange={(e) => {
                const value = e.target.value;

                if (value.includes(",")) {
                  message.error("Amount should be not contain a comma");
                  return;
                }

                const items = [...state.debit_memo_items];
                items[index] = {
                  ...items[index],
                  claim_amount: value,
                };

                setState((prevState) => ({
                  ...prevState,
                  debit_memo_items: items,
                }));
              }}
            />
          ) : (
            numberFormat(value)
          )}
        </span>
      ),
    },

    {
      title: "",
      width: 50,
      render: (value, record, index) =>
        record.footer !== 1 && (
          <Checkbox
            onChange={(e) => {
              const checked = e.target.checked;
              let items;
              if (checked) {
                items = [...state.debit_memo_items];
                items[index] = {
                  ...items[index],
                  claim_amount: round(items[index].balance),
                };
              } else {
                items = [...state.items];
                items[index] = {
                  ...items[index],
                  claim_amount: "",
                };
              }
              setState((prevState) => {
                return {
                  ...prevState,
                  debit_memo_items: items,
                };
              });
            }}
          />
        ),
      align: "center",
    },

    {
      title: "",
      key: "action",
      width: 50,
      align: "center",
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) &&
            isEmpty(state.deleted) &&
            record.footer !== 1 && (
              <DeleteOutlined
                onClick={() =>
                  onDeleteItem({
                    field: "debit_memo_items",
                    index,
                    setState,
                  })
                }
              />
            )}
        </span>
      ),
    },
  ];
  const concessionare_items_column = [
    {
      title: "Doc #",
      dataIndex: "doc_no",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date, record) =>
        record.footer !== 1 && moment(date).format("MM/DD/YYYY"),
    },

    {
      title: "Supplier",
      dataIndex: ["supplier"],
      render: (supplier, record) =>
        record.footer !== 1 && `${supplier?.account_code} - ${supplier?.name}`,
    },
    {
      title: "Period Covered",
      dataIndex: ["period_covered"],
      render: (period_covered, record) => {
        return (
          record.footer !== 1 &&
          `${moment(period_covered?.[0]).format("MM/DD/YYYY")} - ${moment(
            period_covered?.[1]
          ).format("MM/DD/YYYY")}`
        );
      },
      width: 200,
    },
    {
      title: "Reference",
      dataIndex: "reference",
      width: 80,
      align: "center",
    },

    {
      title: "Amount",
      dataIndex: ["amount"],
      width: 150,
      align: "right",
      render: (value) => numberFormat(value),
    },

    {
      title: "Balance after Payment",
      dataIndex: "balance",
      width: 150,
      align: "right",
      render: (value, record, index) => (
        <div
          onClick={(e) => {
            e.preventDefault();
            const concessionare_items = [...state.concessionare_items];
            concessionare_items[index] = {
              ...concessionare_items[index],
              payment_amount: round(value),
            };

            setState((prevState) => ({
              ...prevState,
              concessionare_items,
            }));
          }}
        >
          {numberFormat(value)}
        </div>
      ),
    },
    {
      title: "Payment Amount",
      dataIndex: "payment_amount",
      align: "right",
      width: 150,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 ? (
            <Input
              type="number"
              step={0.01}
              value={value}
              onBlur={(e) => {
                if (!isEmpty(e.target.value)) {
                  axios
                    .get(`/api/account-settings/${SETTING_ACCOUNTS_PAYABLE}`)
                    .then((response) => {
                      if (response.data) {
                        setState((prevState) => ({
                          ...prevState,
                          accounts_payable_account:
                            response.data?.value || null,
                        }));
                      }
                    })
                    .catch((err) =>
                      message.error("There was an error getting A/P Account")
                    );
                }
              }}
              onChange={(e) => {
                const value = e.target.value;

                if (value.includes(",")) {
                  message.error("Amount should be not contain a comma");
                  return;
                }

                const concessionare_items = [...state.concessionare_items];
                concessionare_items[index] = {
                  ...concessionare_items[index],
                  payment_amount: value,
                };

                setState((prevState) => ({
                  ...prevState,
                  concessionare_items,
                }));
              }}
            />
          ) : (
            numberFormat(value)
          )}
        </span>
      ),
    },

    {
      title: "",
      width: 50,
      render: (value, record, index) =>
        record.footer !== 1 && (
          <Checkbox
            onChange={(e) => {
              const checked = e.target.checked;
              let concessionare_items;
              if (checked) {
                concessionare_items = [...state.concessionare_items];
                concessionare_items[index] = {
                  ...concessionare_items[index],
                  payment_amount: round(concessionare_items[index].balance),
                };
              } else {
                concessionare_items = [...state.concessionare_items];
                concessionare_items[index] = {
                  ...concessionare_items[index],
                  payment_amount: "",
                };
              }
              setState((prevState) => {
                return {
                  ...prevState,
                  concessionare_items: concessionare_items,
                };
              });
            }}
          />
        ),
      align: "center",
    },

    {
      title: "",
      key: "action",
      width: 100,
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) &&
            isEmpty(state.deleted) &&
            record.footer !== 1 && (
              <DeleteOutlined
                onClick={() =>
                  onDeleteItem({
                    field: "concessionare_items",
                    index,
                    setState,
                  })
                }
              />
            )}
        </span>
      ),
    },
  ];

  const item_discounts_column = [
    {
      title: "Account",
      dataIndex: ["chart_of_account", "name"],
    },
    {
      title: "Branch",
      dataIndex: ["warehouse", "name"],
    },
    {
      title: "Amount",
      dataIndex: "amount",
      width: 150,
      align: "right",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "",
      key: "action",
      width: 100,
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) &&
            isEmpty(state.deleted) &&
            record.footer !== 1 && (
              <DeleteOutlined
                onClick={() =>
                  onDeleteItem({
                    field: "discount_items",
                    index,
                    setState,
                  })
                }
              />
            )}
        </span>
      ),
    },
  ];

  const item_deductions_column = [
    {
      title: "Account",
      dataIndex: ["chart_of_account", "name"],
    },
    {
      title: "Branch",
      dataIndex: ["warehouse", "name"],
    },
    {
      title: "Amount",
      dataIndex: "amount",
      width: 150,
      align: "right",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "",
      key: "action",
      width: 100,
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) &&
            isEmpty(state.deleted) &&
            record.footer !== 1 && (
              <DeleteOutlined
                onClick={() =>
                  onDeleteItem({
                    field: "deduction_items",
                    index,
                    setState,
                  })
                }
              />
            )}
        </span>
      ),
    },
  ];

  const item_expenses_column = [
    {
      title: "Account",
      dataIndex: ["chart_of_account", "name"],
    },
    {
      title: "Branch",
      dataIndex: ["warehouse", "name"],
    },
    {
      title: "Amount",
      dataIndex: "amount",
      width: 150,
      align: "right",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "",
      key: "action",
      width: 100,
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) &&
            isEmpty(state.deleted) &&
            record.footer !== 1 && (
              <DeleteOutlined
                onClick={() =>
                  onDeleteItem({
                    field: "expense_items",
                    index,
                    setState,
                  })
                }
              />
            )}
        </span>
      ),
    },
  ];

  const advance_payment_column = [
    {
      title: "PO #",
      dataIndex: "po_no",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date, record) =>
        record.footer !== 1 && moment(date).format("MM/DD/YYYY"),
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      width: 150,
      align: "right",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "Balance",
      dataIndex: "balance",
      width: 150,
      align: "right",
      render: (value, record, index) => (
        <div
          onClick={(e) => {
            e.preventDefault();

            const advance_payment_items = [...state.advance_payment_items];
            advance_payment_items[index] = {
              ...advance_payment_items[index],
              payment_amount: value,
            };

            setState((prevState) => ({
              ...prevState,
              advance_payment_items,
            }));
          }}
        >
          {numberFormat(value)}
        </div>
      ),
    },
    {
      title: "Payment Amount",
      dataIndex: "payment_amount",
      align: "right",
      width: 150,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 ? (
            <Input
              value={value}
              onChange={(e) => {
                const value = e.target.value;

                if (value.includes(",")) {
                  message.error("Amount should be not contain a comma");
                  return;
                }

                const advance_payment_items = [...state.advance_payment_items];
                advance_payment_items[index] = {
                  ...advance_payment_items[index],
                  payment_amount: value,
                };

                setState((prevState) => ({
                  ...prevState,
                  advance_payment_items,
                }));
              }}
            />
          ) : (
            numberFormat(value)
          )}
        </span>
      ),
    },

    {
      title: "",
      key: "action",
      width: 100,
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) &&
            isEmpty(state.deleted) &&
            record.footer !== 1 && (
              <DeleteOutlined
                onClick={() =>
                  onDeleteItem({
                    field: "advance_payment_items",
                    index,
                    setState,
                  })
                }
              />
            )}
        </span>
      ),
    },
  ];

  const credit_memo_items_column = [
    {
      title: "PR #",
      dataIndex: "pr_no",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date, record) =>
        record.footer !== 1 && moment(date).format("MM/DD/YYYY"),
    },

    {
      title: "Invoice #",
      dataIndex: "invoice_no",
    },
    {
      title: "Invoice Date",
      dataIndex: "date",
      render: (date, record) =>
        record.footer !== 1 && date && moment(date).format("MM/DD/YYYY"),
    },

    {
      title: "Remarks",
      dataIndex: "remarks",
    },
    {
      title: "WTax Applicable",
      dataIndex: "is_wtax_applicable",
      width: 80,
      align: "center",
      render: (value, record) =>
        record.footer !== 1 && <span>{value ? "YES" : "NO"}</span>,
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      width: 150,
      align: "right",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "Balance",
      dataIndex: "balance",
      width: 150,
      align: "right",
      render: (value, record, index) => (
        <div
          onClick={(e) => {
            e.preventDefault();
            const credit_memo_items = [...state.credit_memo_items];
            credit_memo_items[index] = {
              ...credit_memo_items[index],
              credit_amount: value,
            };

            setState((prevState) => ({
              ...prevState,
              credit_memo_items,
            }));
          }}
        >
          {numberFormat(value)}
        </div>
      ),
    },
    {
      title: "CM Amount",
      dataIndex: "credit_amount",
      align: "right",
      width: 150,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 ? (
            <Input
              type="number"
              value={value}
              onChange={(e) => {
                const credit_memo_items = [...state.credit_memo_items];
                credit_memo_items[index] = {
                  ...credit_memo_items[index],
                  credit_amount: e.target.value,
                };

                setState((prevState) => ({
                  ...prevState,
                  credit_memo_items,
                }));
              }}
            />
          ) : (
            numberFormat(value)
          )}
        </span>
      ),
    },

    {
      title: "",
      width: 50,
      render: (value, record, index) =>
        record.footer !== 1 && (
          <Checkbox
            onChange={(e) => {
              const checked = e.target.checked;
              let credit_memo_items;
              if (checked) {
                credit_memo_items = [...state.credit_memo_items];
                credit_memo_items[index] = {
                  ...credit_memo_items[index],
                  credit_amount: round(credit_memo_items[index].balance),
                };
              } else {
                credit_memo_items = [...state.credit_memo_items];
                credit_memo_items[index] = {
                  ...credit_memo_items[index],
                  credit_amount: "",
                };
              }
              setState((prevState) => {
                return {
                  ...prevState,
                  credit_memo_items: credit_memo_items,
                };
              });
            }}
          />
        ),
      align: "center",
    },
    {
      title: "",
      key: "action",
      width: 50,
      align: "center",
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) &&
            isEmpty(state.deleted) &&
            record.footer !== 1 && (
              <DeleteOutlined
                onClick={() =>
                  onDeleteItem({
                    field: "credit_memo_items",
                    index,
                    setState,
                  })
                }
              />
            )}
        </span>
      ),
    },
  ];

  const additional_debit_memo_items_column = [
    {
      title: "Invoice #",
      dataIndex: "invoice_no",
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              name="invoice_no"
              className="input-value"
              value={value}
              type="text"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let additional_debit_memo_items = [
                    ...(prevState.additional_debit_memo_items || []),
                  ];

                  additional_debit_memo_items[index][target.name] =
                    target.value;

                  if (additional_debit_memo_items.length - 1 === index) {
                    additional_debit_memo_items.push({});
                  }

                  return {
                    ...prevState,
                    additional_debit_memo_items,
                  };
                });
              }}
            />
          )
        );
      },
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              name="invoice_date"
              value={value}
              className="input-value"
              type="text"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let additional_debit_memo_items = [
                    ...(prevState.additional_debit_memo_items || []),
                  ];

                  additional_debit_memo_items[index][target.name] =
                    target.value;

                  if (additional_debit_memo_items.length - 1 === index) {
                    additional_debit_memo_items.push({});
                  }

                  return {
                    ...prevState,
                    additional_debit_memo_items,
                  };
                });
              }}
            />
          )
        );
      },
    },

    {
      title: "Description",
      dataIndex: "description",
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              name="description"
              value={value}
              className="input-value"
              type="text"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let additional_debit_memo_items = [
                    ...(prevState.additional_debit_memo_items || []),
                  ];

                  additional_debit_memo_items[index][target.name] =
                    target.value;

                  if (additional_debit_memo_items.length - 1 === index) {
                    additional_debit_memo_items.push({});
                  }

                  return {
                    ...prevState,
                    additional_debit_memo_items,
                  };
                });
              }}
            />
          )
        );
      },
    },

    {
      title: "Expense Category",
      dataIndex: ["expense_category"],
      render: (expense_category, record, record_index) => {
        return (
          record.footer !== 1 && (
            <SelectFieldGroup
              value={expense_category?.name}
              onSearch={(value) =>
                onExpenseCategorySearch({ value, options, setOptions })
              }
              onFocus={() =>
                onExpenseCategorySearch({ value: "", options, setOptions })
              }
              onChange={(index) => {
                const expense_category =
                  options.expense_categories?.[index] || null;

                if (expense_category) {
                  setState((prevState) => {
                    const items = [
                      ...(prevState.additional_debit_memo_items || []),
                    ];

                    items[record_index].expense_category = expense_category;

                    return {
                      ...prevState,
                      additional_debit_memo_items: items,
                    };
                  });
                }
              }}
              error={errors.stock?.name}
              formItemLayout={null}
              data={options.expense_categories}
              column="display_name"
              onAddItem={() =>
                expenseCategoryFormModal.current.open(
                  record_index,
                  "additional_debit_memo_items"
                )
              }
            />
          )
        );
      },
    },

    // {
    //   title: "W/Tax",
    //   dataIndex: "is_wtax_applicable",
    //   width: 150,
    //   align: "center",
    //   render: (value, record, index) => {
    //     return (
    //       record.footer !== 1 && (
    //         <input
    //           checked={value || false}
    //           name="is_wtax_applicable"
    //           className="input-value has-text-right"
    //           type="checkbox"
    //           step={0.01}
    //           onChange={(e) => {
    //             const target = e.target;

    //             setState((prevState) => {
    //               let additional_debit_memo_items = [
    //                 ...(prevState.additional_debit_memo_items || []),
    //               ];

    //               additional_debit_memo_items[index][target.name] =
    //                 target.checked;

    //               if (additional_debit_memo_items.length - 1 === index) {
    //                 additional_debit_memo_items.push({});
    //               }

    //               return {
    //                 ...prevState,
    //                 additional_debit_memo_items,
    //               };
    //             });
    //           }}
    //         />
    //       )
    //     );
    //   },
    // },

    {
      title: "Total Amount",
      dataIndex: "amount",
      width: 150,
      align: "right",
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              value={value}
              name="amount"
              className="input-value has-text-right"
              type="number"
              step={0.01}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let additional_debit_memo_items = [
                    ...(prevState.additional_debit_memo_items || []),
                  ];

                  additional_debit_memo_items[index][target.name] =
                    target.value;

                  if (additional_debit_memo_items.length - 1 === index) {
                    additional_debit_memo_items.push({});
                  }

                  return {
                    ...prevState,
                    additional_debit_memo_items,
                  };
                });
              }}
            />
          )
        );
      },
    },

    {
      title: "",
      key: "action",
      width: 50,
      align: "center",
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) &&
            isEmpty(state.deleted) &&
            record.footer !== 1 && (
              <DeleteOutlined
                onClick={() =>
                  onDeleteItem({
                    field: "additional_debit_memo_items",
                    index,
                    setState,
                  })
                }
              />
            )}
        </span>
      ),
    },
  ];

  const addback_items_column = [
    {
      title: "Invoice #",
      dataIndex: "invoice_no",
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              name="invoice_no"
              className="input-value"
              value={value}
              type="text"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let addback_items = [...(prevState.addback_items || [])];

                  addback_items[index][target.name] = target.value;

                  if (addback_items.length - 1 === index) {
                    addback_items.push({});
                  }

                  return {
                    ...prevState,
                    addback_items,
                  };
                });
              }}
            />
          )
        );
      },
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              name="invoice_date"
              value={value}
              className="input-value"
              type="text"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let addback_items = [...(prevState.addback_items || [])];

                  addback_items[index][target.name] = target.value;

                  if (addback_items.length - 1 === index) {
                    addback_items.push({});
                  }

                  return {
                    ...prevState,
                    addback_items,
                  };
                });
              }}
            />
          )
        );
      },
    },

    {
      title: "Description",
      dataIndex: "description",
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              name="description"
              value={value}
              className="input-value"
              type="text"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let addback_items = [...(prevState.addback_items || [])];

                  addback_items[index][target.name] = target.value;

                  if (addback_items.length - 1 === index) {
                    addback_items.push({});
                  }

                  return {
                    ...prevState,
                    addback_items,
                  };
                });
              }}
            />
          )
        );
      },
    },

    {
      title: "Total Amount",
      dataIndex: "amount",
      width: 150,
      align: "right",
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              value={value}
              name="amount"
              className="input-value has-text-right"
              type="number"
              step={0.01}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let addback_items = [...(prevState.addback_items || [])];

                  addback_items[index][target.name] = target.value;

                  if (addback_items.length - 1 === index) {
                    addback_items.push({});
                  }

                  return {
                    ...prevState,
                    addback_items,
                  };
                });
              }}
            />
          )
        );
      },
    },

    {
      title: "",
      key: "action",
      width: 50,
      align: "center",
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) &&
            isEmpty(state.deleted) &&
            record.footer !== 1 && (
              <DeleteOutlined
                onClick={() =>
                  onDeleteItem({
                    field: "addback_items",
                    index,
                    setState,
                  })
                }
              />
            )}
        </span>
      ),
    },
  ];

  const additional_items_column = [
    {
      title: "Invoice #",
      dataIndex: "invoice_no",
      width: 100,
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              name="invoice_no"
              className="input-value"
              value={value}
              type="text"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let additional_items = [
                    ...(prevState.additional_items || []),
                  ];

                  additional_items[index][target.name] = target.value;

                  if (additional_items.length - 1 === index) {
                    additional_items.push({});
                  }

                  return {
                    ...prevState,
                    additional_items,
                  };
                });
              }}
            />
          )
        );
      },
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      width: 120,
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              name="invoice_date"
              value={value}
              className="input-value"
              type="text"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let additional_items = [
                    ...(prevState.additional_items || []),
                  ];

                  additional_items[index][target.name] = target.value;

                  if (additional_items.length - 1 === index) {
                    additional_items.push({});
                  }

                  return {
                    ...prevState,
                    additional_items,
                  };
                });
              }}
            />
          )
        );
      },
    },

    {
      title: "Description",
      dataIndex: "description",
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              name="description"
              className="input-value"
              value={value}
              type="text"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let additional_items = [
                    ...(prevState.additional_items || []),
                  ];

                  additional_items[index][target.name] = target.value;

                  if (additional_items.length - 1 === index) {
                    additional_items.push({});
                  }

                  return {
                    ...prevState,
                    additional_items,
                  };
                });
              }}
            />
          )
        );
      },
    },
    {
      title: "Expense Category",
      dataIndex: ["expense_category"],
      render: (expense_category, record, record_index) => {
        return (
          record.footer !== 1 && (
            <SelectFieldGroup
              value={expense_category?.name}
              onSearch={(value) =>
                onExpenseCategorySearch({ value, options, setOptions })
              }
              onFocus={() =>
                onExpenseCategorySearch({ value: "", options, setOptions })
              }
              onChange={(index) => {
                const expense_category =
                  options.expense_categories?.[index] || null;

                if (expense_category) {
                  setState((prevState) => {
                    const items = [...(prevState.additional_items || [])];

                    items[record_index].expense_category = expense_category;

                    return {
                      ...prevState,
                      additional_items: items,
                    };
                  });
                }
              }}
              error={errors.stock?.name}
              formItemLayout={null}
              data={options.expense_categories}
              column="display_name"
              onAddItem={() =>
                expenseCategoryFormModal.current.open(
                  record_index,
                  "additional_items"
                )
              }
            />
          )
        );
      },
    },
    ,
    /* {
      title: "Non Vat",
      dataIndex: "is_non_vat",
      width: 150,
      align: "center",
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              checked={value || false}
              name="is_non_vat"
              className="input-value has-text-right"
              type="checkbox"
              step={0.01}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let additional_items = [
                    ...(prevState.additional_items || []),
                  ];

                  additional_items[index][target.name] = target.checked;

                  if (additional_items.length - 1 === index) {
                    additional_items.push({});
                  }

                  return {
                    ...prevState,
                    additional_items,
                  };
                });
              }}
            />
          )
        );
      },
    } */ {
      title: "Total Amount",
      dataIndex: "amount",
      width: 150,
      align: "right",
      render: (value, record, index) => {
        return (
          record.footer !== 1 && (
            <input
              value={value}
              name="amount"
              className="input-value has-text-right"
              type="number"
              step={0.01}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                const target = e.target;

                setState((prevState) => {
                  let additional_items = [
                    ...(prevState.additional_items || []),
                  ];

                  additional_items[index][target.name] = target.value;

                  if (additional_items.length - 1 === index) {
                    additional_items.push({});
                  }

                  return {
                    ...prevState,
                    additional_items,
                  };
                });
              }}
            />
          )
        );
      },
    },

    {
      title: "",
      key: "action",
      width: 50,
      align: "center",
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) &&
            isEmpty(state.deleted) &&
            record.footer !== 1 && (
              <DeleteOutlined
                onClick={() =>
                  onDeleteItem({
                    field: "additional_items",
                    index,
                    setState,
                  })
                }
              />
            )}
        </span>
      ),
    },
  ];

  const po_credit_column = [
    {
      title: "PO #",
      dataIndex: "po_no",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date, record) =>
        record.footer !== 1 && moment(date).format("MM/DD/YYYY"),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      width: 150,
      align: "right",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "Balance",
      dataIndex: "balance",
      width: 150,
      align: "right",
      render: (value, record, index) => (
        <div
          onClick={() => {
            const po_credit_items = [...state.po_credit_items];
            po_credit_items[index] = {
              ...po_credit_items[index],
              credit_amount: value,
            };

            setState((prevState) => ({
              ...prevState,
              po_credit_items,
            }));
          }}
        >
          {numberFormat(value)}
        </div>
      ),
    },
    {
      title: "CM Amount",
      dataIndex: "credit_amount",
      align: "right",
      width: 150,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 ? (
            <Input
              type="number"
              value={value}
              onChange={(e) => {
                const po_credit_items = [...state.po_credit_items];
                po_credit_items[index] = {
                  ...po_credit_items[index],
                  credit_amount: e.target.value,
                };

                setState((prevState) => ({
                  ...prevState,
                  po_credit_items,
                }));
              }}
            />
          ) : (
            numberFormat(value)
          )}
        </span>
      ),
    },

    {
      title: "",
      key: "action",
      width: 50,
      align: "center",
      render: (text, record, index) => (
        <span>
          {isEmpty(state.status) &&
            isEmpty(state.deleted) &&
            record.footer !== 1 && (
              <DeleteOutlined
                onClick={() =>
                  onDeleteItem({
                    field: "po_credit_items",
                    index,
                    setState,
                  })
                }
              />
            )}
        </span>
      ),
    },
  ];

  const onChangeSupplier = (supplier, period_covered) => {
    if (supplier) {
      const loading = message.loading("Loading...");
      axios
        .post(`/api/check-vouchers/items`, { supplier, period_covered })
        .then((response) => {
          loading();
          if (response.data) {
            setState((prevState) => ({
              ...prevState,
              check_name: supplier.name,
              items: [...(response.data.purchase_orders || [])],
              debit_memo_items: [...(response.data.debit_memos || [])],
              // po_credit_items: [...response.data.po_credit],
              additional_debit_memo_items: [{}],
            }));
          } else {
            setState((prevState) => ({
              ...prevState,
              check_name: supplier.name,
            }));
          }
        })
        .catch((err) => {
          loading();
        });
    }
  };

  const getDefaultBank = useCallback(() => {
    axios
      .get("/api/chart-of-accounts/default-bank")
      .then((response) => {
        setState((prevState) => ({
          ...prevState,
          bank: response.data,
        }));
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    axios
      .get("/api/payment-methods")
      .then((response) => {
        if (response.data) {
          setOptions((prevState) => ({
            ...prevState,
            payment_methods: response.data.map((o) => o.name),
          }));
        }
      })
      .catch((err) => {
        return message.error("There was an error processing your request");
      });

    return () => {};
  }, []);

  useEffect(() => {
    //get default bank
    getDefaultBank();

    return () => {};
  }, []);

  useEffect(() => {
    setState((prevState) => {
      let total_amount = sumBy(state.items, (o) =>
        round(o.payment_amount || 0)
      );

      const received_items_amount = total_amount;

      total_amount += sumBy(state.additional_items, (o) =>
        round(o.amount || 0)
      );
      total_amount -= sumBy(state.additional_debit_memo_items || [], (o) =>
        round(o.amount || 0)
      );

      total_amount -= sumBy(state.debit_memo_items || [], (o) =>
        round(o.claim_amount || 0)
      );

      const total_expenses = round(
        sumBy(state?.expense_items || [], (o) => round(o.amount || 0))
      );

      const total_accounts_payable = round(
        total_amount +
          // total_wtax_credit_amount -
          // total_no_wtax_credit_amount +
          // total_concessionare_amount +
          total_expenses
      );

      const net_amount = round(total_accounts_payable);

      // let wtax_based_amount = round(
      //   total_amount +
      //     total_concessionare_amount +
      //     total_expenses -
      //     total_wtax_credit_amount
      // );
      // let wtax_amount = 0;

      // if (state.wtax_type === VAT_TYPE_PERCENT) {
      //   if (state.supplier?.tax_type === TAX_TYPE_VAT) {
      //     const wtax_based_amount = round(
      //       received_items_amount +
      //         additional_items_vat +
      //         total_concessionare_amount +
      //         total_expenses -
      //         total_wtax_credit_amount
      //     );

      //     wtax_amount = round(
      //       ((wtax_based_amount / 1.12) * state.wtax_rate) / 100
      //     );
      //   } else {
      //     wtax_amount = round((wtax_based_amount * state.wtax_rate) / 100);
      //   }
      // } else {
      //   wtax_amount = state.wtax_rate;
      // }

      // const total_deductions = round(
      //   sumBy(state.deduction_items, (o) => round(o.amount || 0))
      // );

      const addback_items_amount = round(
        sumBy(state.addback_items || [], (o) => parseFloat(o.amount || 0))
      );

      let voucher_amount = round(net_amount + addback_items_amount);

      return {
        ...prevState,

        net_amount,
        // wtax_amount,
        voucher_amount,
        total_accounts_payable,
        // total_concessionare_amount,
        total_expenses,
        // total_wtax_credit_amount,
        // total_no_wtax_credit_amount,
        total_amount,
        addback_items_amount,
      };
    });

    return () => {};
  }, [
    state.wtax_rate,
    state.wtax_type,
    state.items,
    state.credit_memo_items,
    state.advance_payment_items,
    state.po_credit_items,
    state.discount_items,
    state.deduction_items,
    state.expense_items,
    state.concessionare_items,
    state.supplier,
    state.additional_debit_memo_items,
    state.additional_items,
    state.addback_items,
  ]);

  const record_buttons = (
    <RecordButtons
      state_loading={state_loading}
      setStateLoading={setStateLoading}
      url={url}
      auth={auth}
      state={records?.[row_selected]}
      onSearch={() => {
        setState(initialValues);
        setItem(initialItemValues);
        onSearch({
          page: current_page,
          search_keyword,
          url,
          setRecords,
          setTotalRecords,
          setCurrentPage,
          setErrors,
          advance_search: search_state,
          page_size,
        });
      }}
      has_approve={isEmpty(records?.[row_selected]?.status?.approval_status)}
      void_text="Cancel"
      transaction="check-vouchers"
      onNew={() => {
        setState({ ...initialValues, date: moment() });
        setItem({});
        setDiscountItem({});
        setDeductionItem({});
        setExpenseItem({});
        setRecords([]);

        getDefaultBank();
      }}
    />
  );

  return (
    <Content className="content-padding">
      <WarehouseFormModal
        setField={(warehouse) => {
          setState((prevState) => ({
            ...prevState,
            warehouse,
          }));
        }}
        ref={warehouseFormModal}
      />

      <ExpenseCategoryFormModal
        setField={({ record, index, column }) => {
          console.log(index);
          setState((prevState) => {
            const items = [...prevState[column]];
            items[index].expense_category = record;

            return {
              ...prevState,
              [column]: items,
            };
          });
        }}
        ref={expenseCategoryFormModal}
      />

      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* Start of Advance Search */}
      <Row>
        <Col span={24} className="m-b-1">
          <Collapse>
            <Panel header="Advance Search">
              <PageHeader
                backIcon={false}
                style={{
                  border: "1px solid rgb(235, 237, 240)",
                }}
                onBack={() => null}
                title="Advance Filter"
                subTitle="Enter appropriate data to filter records"
              >
                <div className="or-slip-form">
                  <Row>
                    <Col span={8}>
                      <RangeDatePickerFieldGroup
                        label="Date"
                        name="period_covered"
                        value={search_state.period_covered}
                        onChange={(dates) =>
                          setSearchState((prevState) => ({
                            ...prevState,
                            period_covered: dates,
                          }))
                        }
                        formItemLayout={smallFormItemLayout}
                      />
                    </Col>
                    <Col span={8}>
                      <SelectFieldGroup
                        label="Supplier"
                        value={search_state.supplier?.name}
                        onSearch={(value) =>
                          onSupplierSearch({ value, options, setOptions })
                        }
                        onChange={(index) => {
                          const supplier = options.accounts[index];
                          console.log(supplier);
                          setSearchState((prevState) => ({
                            ...prevState,
                            supplier,
                          }));
                        }}
                        formItemLayout={smallFormItemLayout}
                        data={options.accounts}
                        column="name"
                      />
                    </Col>
                    <Col span={8}>
                      <TextFieldGroup
                        label="CV #"
                        name="cv_no"
                        formItemLayout={smallFormItemLayout}
                        value={search_state.cv_no}
                        onChange={(e) => {
                          onChange({
                            key: e.target.name,
                            value: e.target.value,
                            setState: setSearchState,
                          });
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={8}>
                      <TextFieldGroup
                        label="PO #"
                        name="po_no"
                        formItemLayout={smallFormItemLayout}
                        value={search_state.po_no}
                        onChange={(e) => {
                          onChange({
                            key: e.target.name,
                            value: e.target.value,
                            setState: setSearchState,
                          });
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={8}>
                      <Row>
                        <Col offset={8} span={12}>
                          <Button
                            type="info"
                            size="small"
                            icon={<SearchOutlined />}
                            onClick={() => {
                              onSearch({
                                page: 1,
                                search_keyword,
                                url,
                                setRecords,
                                setTotalRecords,
                                setCurrentPage,
                                setErrors,
                                advance_search: search_state,
                                page_size,
                              });
                            }}
                          >
                            Search
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={8}></Col>
                    <Col span={8}></Col>
                  </Row>
                </div>
              </PageHeader>
            </Panel>
          </Collapse>
        </Col>
      </Row>
      {/* End of Advanced Search */}

      <div style={{ background: "#fff", padding: 24 }}>
        <span className="module-title">{title}</span>
        <Divider />
        {isEmpty(records) ? (
          <Form
            onFinish={(values) =>
              onSubmit({
                values: {
                  ...state,
                  items: (state.items || [])?.filter(
                    (o) => ![undefined, null, ""].includes(o.payment_amount)
                  ),
                  additional_debit_memo_items: (
                    state.additional_debit_memo_items || []
                  ).filter((o) => ![undefined, null, ""].includes(o.amount)),
                  additional_items: (state.additional_items || []).filter(
                    (o) => round(o.amount) > 0
                  ),
                },
                auth,
                url,
                setErrors,
                setState,
                date_fields,
                setLoading,
              })
            }
            initialValues={initialValues}
          >
            {state[transaction_counter.key] && (
              <TextFieldGroup
                label={transaction_counter.label}
                value={state[transaction_counter.key]}
                error={errors.remarks}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}
            <DatePickerFieldGroup
              label="Date"
              name="date"
              value={state.date}
              onChange={(value) => {
                onChange({
                  key: "date",
                  value: value,
                  setState,
                });
              }}
              error={errors.date}
              formItemLayout={formItemLayout}
            />
            <Row>
              <Col span={12}>
                <SelectFieldGroup
                  label="Supplier"
                  value={state.supplier && `${state.supplier?.name}`}
                  onSearch={(value) => onSupplierSearch({ value, setOptions })}
                  onChange={(index) => {
                    const supplier = options.accounts?.[index] || null;

                    setState((prevState) => ({
                      ...prevState,
                      ...(supplier?._id && {
                        check_name: supplier?.name,
                      }),
                      supplier,
                      items: [],
                      credit_memo_items: [],
                      advance_payment_items: [],
                      po_credit_items: [],
                      discount_items: [],
                      deduction_items: [],
                      expense_items: [],
                      additional_debit_memo_items: [
                        {
                          invoice_no: "",
                          invoice_date: "",
                          amount: "",
                          is_wtax_applicable: false,
                          description: "",
                        },
                      ],
                      additional_items: [
                        {
                          invoice_no: "",
                          invoice_date: "",
                          amount: "",
                          is_wtax_applicable: false,
                          description: "",
                        },
                      ],
                    }));
                  }}
                  error={errors.supplier}
                  formItemLayout={smallFormItemLayout}
                  data={options.accounts}
                  column="name"
                />
              </Col>
              {/* <Col span={12}>
                <TextFieldGroup
                  disabled
                  label="Tax Type"
                  name="tax_type"
                  formItemLayout={smallFormItemLayout}
                  value={state.supplier?.tax_type || ""}
                />
              </Col> */}
            </Row>
            <Divider />
            <Row>
              <Col span={12}>
                <RangeDatePickerFieldGroup
                  label="Due Date"
                  name="due_date_period_covered"
                  value={state.due_date_period_covered}
                  onChange={(dates) =>
                    setState((prevState) => ({
                      ...prevState,
                      due_date_period_covered: dates,
                    }))
                  }
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
              <Col span={12}>
                <Button
                  onClick={() => {
                    onChangeSupplier(
                      state.supplier,
                      state.due_date_period_covered
                    );
                  }}
                >
                  Search Due Invoices
                </Button>
              </Col>
            </Row>
            <Divider />
            <SimpleSelectFieldGroup
              label="Payment Method"
              name="payment_method"
              value={state.payment_method}
              onChange={(value) => {
                setState((prevState) => ({
                  ...prevState,
                  payment_method: value,
                }));
              }}
              error={errors?.payment_method}
              options={options?.payment_methods || []}
              formItemLayout={formItemLayout}
            />
            <TextFieldGroup
              label="Payment Reference"
              name="payment_reference"
              error={errors.payment_reference}
              formItemLayout={formItemLayout}
              value={state.payment_reference}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
            />

            <SelectFieldGroup
              label="Source"
              value={state.bank?.name}
              onFocus={() => {
                onBankSearch({ value: "", options, setOptions });
              }}
              onSearch={(value) => onBankSearch({ value, options, setOptions })}
              onChange={(index) => {
                const bank = options.banks[index];

                setState((prevState) => ({
                  ...prevState,
                  bank,
                }));
              }}
              error={errors.bank}
              formItemLayout={formItemLayout}
              data={options.banks}
              column="name"
            />

            {state.payment_method?.toUpperCase() ===
              PAYMENT_TYPE_CHECK?.toUpperCase() && (
              <div>
                <TextFieldGroup
                  label="Check Name"
                  name="check_name"
                  error={errors.check_name}
                  formItemLayout={formItemLayout}
                  value={state.check_name}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                />

                <TextFieldGroup
                  label="Check No."
                  name="check_no"
                  error={errors.check_no}
                  formItemLayout={formItemLayout}
                  value={state.check_no}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                />
                <DatePickerFieldGroup
                  label="Check Date"
                  name="check_date"
                  value={state.check_date}
                  onChange={(value) => {
                    onChange({
                      key: "check_date",
                      value: value,
                      setState,
                    });
                  }}
                  error={errors.check_date}
                  formItemLayout={formItemLayout}
                />
              </div>
            )}

            <TextFieldGroup
              label="Amount"
              disabled={true}
              formItemLayout={formItemLayout}
              value={numberFormat(state.voucher_amount)}
              readOnly
            />
            {/* <SelectFieldGroup
              label="A/P Account"
              value={state.accounts_payable_account?.name}
              onSearch={(value) =>
                onChartOfAccountSearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const accounts_payable_account =
                  options.chart_of_accounts[index];

                setState((prevState) => ({
                  ...prevState,
                  accounts_payable_account,
                }));
              }}
              error={errors.accounts_payable_account}
              formItemLayout={formItemLayout}
              data={options.chart_of_accounts}
              column="name"
            /> */}
            {/* <SelectFieldGroup
              label="WTax Account"
              value={state.wtax_account?.name}
              onSearch={(value) =>
                onChartOfAccountSearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const wtax_account = options.chart_of_accounts[index];

                setState((prevState) => ({
                  ...prevState,
                  wtax_account,
                }));
              }}
              error={errors.wtax_account}
              formItemLayout={formItemLayout}
              data={options.chart_of_accounts}
              column="name"
            /> */}
            <TextAreaGroup
              label="Remarks"
              name="remarks"
              value={state.remarks}
              error={errors.remarks}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
            />

            {state.status && state.status.datetime && (
              <TextFieldGroup
                label="Status"
                name="status"
                value={`${state.status.approval_status} / ${
                  state.status.user.name
                } / ${moment(state.status.datetime).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}
            {state.deleted && state.deleted.date && (
              <TextFieldGroup
                label="Voided By"
                name="status"
                value={`${state.deleted?.user?.name} / ${moment(
                  state.deleted.date
                ).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            {(state?.items || [])?.length > 0 && [
              <Divider key="1" />,
              <div key="2">Items</div>,
              <Table
                key="items"
                dataSource={addKeysToArray([
                  ...(state?.items || []),
                  {
                    footer: 1,
                    total_amount: sumBy(state.items, (o) =>
                      round(o.total_amount)
                    ),
                    total_received_amount: sumBy(state.items, (o) =>
                      parseFloat(o.total_received_amount || 0)
                    ),
                    balance: sumBy(state.items, (o) => round(o.balance || 0)),
                    payment_amount: sumBy(state.items, (o) =>
                      round(o.payment_amount || 0)
                    ),
                  },
                ])}
                columns={items_column}
                pagination={false}
                rowClassName={(record, index) => {
                  if (record.footer === 1) {
                    return "footer-summary has-text-weight-bold";
                  }
                }}
              />,
            ]}

            {/* ADDITIONAL ITEMS */}
            <Divider />

            <div>Additional Items</div>
            <Table
              dataSource={addKeysToArray([
                ...(state.additional_items || []),
                {
                  footer: 1,
                  amount: sumBy(state.additional_items || [], (o) =>
                    round(o.amount)
                  ),
                },
              ])}
              columns={additional_items_column}
              pagination={false}
              rowClassName={(record, index) => {
                if (record.footer === 1) {
                  return "footer-summary has-text-weight-bold";
                }
              }}
            />
            {/* END OF ADDITIONAL  ITEMS */}

            {/* DEBIT MEMO OPTIONS */}
            {(state?.debit_memo_items || [])?.length > 0 && [
              <Divider key="1" />,
              <div key="2">Debit Memo Items</div>,

              <Table
                key="items"
                dataSource={addKeysToArray([
                  ...(state?.debit_memo_items || []),
                  {
                    footer: 1,
                    total_amount: sumBy(state.debit_memo_items, (o) =>
                      round(o.total_amount)
                    ),
                    balance: sumBy(state.debit_memo_items, (o) =>
                      round(o.balance || 0)
                    ),
                    claim_amount: sumBy(state.debit_memo_items, (o) =>
                      round(o.claim_amount || 0)
                    ),
                  },
                ])}
                columns={debit_memo_column}
                pagination={false}
                rowClassName={(record, index) => {
                  if (record.footer === 1) {
                    return "footer-summary has-text-weight-bold";
                  }
                }}
              />,
            ]}

            {/* ADDITIONAL DEBIT MEMO ITEMS */}
            <Divider />

            <div>Additional Debit Memo Items</div>
            <Table
              dataSource={addKeysToArray([
                ...(state.additional_debit_memo_items || []),
                {
                  footer: 1,
                  amount: sumBy(state.additional_debit_memo_items, (o) =>
                    round(o.amount)
                  ),
                },
              ])}
              columns={additional_debit_memo_items_column}
              pagination={false}
              rowClassName={(record, index) => {
                if (record.footer === 1) {
                  return "footer-summary has-text-weight-bold";
                }
              }}
            />
            {/* END OF ADDITIONAL DEBIT MEMO ITEMS */}

            {/* START OF ADDBACK ITEMS */}

            {/* ADDITIONAL DEBIT MEMO ITEMS */}
            {/* <Divider />

            <div>Addback Items</div>
            <Table
              dataSource={addKeysToArray([
                ...(state.addback_items || []),
                {
                  footer: 1,
                  amount: sumBy(state.addback_items, (o) => round(o.amount)),
                },
              ])}
              columns={addback_items_column}
              pagination={false}
              rowClassName={(record, index) => {
                if (record.footer === 1) {
                  return "footer-summary has-text-weight-bold";
                }
              }}
            /> */}
            {/* END OF ADDITIONAL DEBIT MEMO ITEMS */}

            {/* END OF ADDBACK ITEMS */}

            {state.total_amount > 0 && (
              <Row>
                <Col span={24} className="has-text-right summary">
                  A/P Amount : {numberFormat(state.total_amount)}
                </Col>
              </Row>
            )}
            {state.total_expenses > 0 && (
              <Row>
                <Col span={24} className="has-text-right summary">
                  Total Expenses : {numberFormat(state.total_expenses)}
                </Col>
              </Row>
            )}
            {state.total_concessionare_amount > 0 && (
              <Row>
                <Col span={24} className="has-text-right summary">
                  Total Concessionare Sales :{" "}
                  {numberFormat(state.total_concessionare_amount)}
                </Col>
              </Row>
            )}
            {state.total_wtax_credit_amount > 0 && (
              <Row>
                <Col span={24} className="has-text-right summary">
                  Less DMs: FREE GOODS/RETURNS/DAMAGED :{" "}
                  {numberFormat(state.total_wtax_credit_amount)}
                </Col>
              </Row>
            )}
            {state.wtax_amount > 0 && (
              <Row>
                <Col span={24} className="has-text-right summary">
                  Less{" "}
                  {state.wtax_type === VAT_TYPE_PERCENT
                    ? `${state.wtax_rate}% W/TAX`
                    : `W/TAX`}
                  :{numberFormat(state.wtax_amount)}
                </Col>
              </Row>
            )}
            {state.total_no_wtax_credit_amount > 0 && (
              <Row>
                <Col span={24} className="has-text-right summary">
                  Less: {numberFormat(state.total_no_wtax_credit_amount)}
                </Col>
              </Row>
            )}
            {state.addback_items_amount > 0 && (
              <Row>
                <Col span={24} className="has-text-right summary">
                  Addback Items : {numberFormat(state.addback_items_amount)}
                </Col>
              </Row>
            )}

            <Row>
              <Col span={24} className="has-text-right summary">
                Check Amount : {numberFormat(state.voucher_amount)}
              </Col>
            </Row>
            <FormButtons
              has_print={false}
              state={state}
              auth={auth}
              loading={loading}
              loading_state={loading_state}
              url={url}
              transaction="check-vouchers"
              onDelete={() => {
                setLoading(true);
                onDelete({
                  id: state._id,
                  url,
                  user: auth.user,
                  setLoadingState,
                  cb: () => {
                    onSearch({
                      page: current_page,
                      page_size,
                      search_keyword,
                      url,
                      setRecords,
                      setTotalRecords,
                      setCurrentPage,
                      setErrors,
                      setLoadingState,
                      advance_search: { ...search_state },
                      cb: () => setLoading(false),
                    });
                  },
                });
              }}
              initialValues={initialValues}
              initialItemValues={initialItemValues}
              setState={setState}
              setItem={setItem}
              onSearch={() => {
                onSearch({
                  page: current_page,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  setLoading,
                  setLoadingState,
                  advance_search: search_state,
                  page_size,
                });
              }}
              additional_buttons={[
                <span
                  key="1"
                  className="button is-outlined is-link  control"
                  onClick={() => {
                    window.open(
                      `/print/check-voucher/${state._id}/check`,
                      "_blank"
                    );
                  }}
                >
                  <span className="icon ">
                    <i className="fas fa-print" />
                  </span>
                  <span>Print Check</span>
                </span>,
                <span
                  key="2"
                  className="button is-outlined is-link  control"
                  onClick={() => {
                    window.open(`/print/check-vouchers/${state._id}`, "_blank");
                  }}
                >
                  <span className="icon ">
                    <i className="fas fa-print" />
                  </span>
                  <span>Print Voucher</span>
                </span>,
              ]}
              // onFinalize={() =>
              //   onFinalize({
              //     id: state._id,
              //     url,
              //     user: auth.user,
              //     edit,
              //     setState,
              //     setErrors,
              //     setRecords,
              //     date_fields,
              //   })
              // }
              onNew={() => {
                setState({
                  ...initialValues,
                  date: moment(),
                  additional_debit_memo_items: [{}],
                  additional_items: [{}],
                  addback_items: [{}],
                });
                setItem(initialItemValues);
                setRecords([]);
              }}
              can_always_print={true}
              void_text="Cancel"
            />
          </Form>
        ) : (
          <div>
            {record_buttons}
            <Table
              dataSource={addKeysToArray(records)}
              columns={records_column}
              rowKey={(record) => record._id}
              pagination={{
                current: current_page,
                defaultCurrent: current_page,
                onChange: (page, page_size) => {
                  setPageSize(page_size);
                  onSearch({
                    page,
                    search_keyword,
                    url,
                    setRecords,
                    setTotalRecords,
                    setCurrentPage,
                    setErrors,
                    advance_search: search_state,
                    page_size,
                  });
                },
                total: total_records,
                pageSize: page_size,
              }}
              onRow={(record, index) => {
                return {
                  onClick: (e) => {
                    setRowSelected(index);
                  },
                  onDoubleClick: (e) => {
                    edit({
                      record,
                      setState: (record) => {
                        setState({
                          ...record,
                          additional_debit_memo_items: [
                            ...(record.additional_debit_memo_items || []),
                            {
                              invoice_no: "",
                              invoice_date: "",
                              amount: "",
                              is_wtax_applicable: false,
                              description: "",
                            },
                          ],
                          additional_items: [
                            ...(record.additional_items || []),
                            {
                              invoice_no: "",
                              invoice_date: "",
                              amount: "",
                              is_wtax_applicable: false,
                              description: "",
                            },
                          ],
                          addback_items: [
                            ...(record.addback_items || []),
                            {
                              invoice_no: "",
                              invoice_date: "",
                              amount: "",
                              description: "",
                            },
                          ],
                        });
                      },
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  },
                };
              }}
              rowClassName={(record, index) => {
                if (row_selected === index) return "row-is-selected";
              }}
            />
            {record_buttons}
          </div>
        )}
      </div>
    </Content>
  );
}
